import { useSelector } from "react-redux";
import { RootState } from "store";

export const useUserCards = () => {
  const userCards = useSelector((state: RootState) => state["USER"].cards);
  return userCards.data;
};
